import { HttpBackend, HttpRequest } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';
import { Environment } from '@dice/app/types/env.type';
import { Profile } from '@dice/app/types/profile.types';
import { ENV, VERSION } from '@dice/config.tokens';
import { UrlService } from '@uirouter/core';
import { NgxLoggerLevel, NGXLoggerServerService } from 'ngx-logger';

@Injectable()
export class LoggingRequestService extends NGXLoggerServerService {
  private urlService = inject(UrlService);

  private variant: string;

  private version: string;

  constructor() {
    const httpBackend = inject(HttpBackend);
    const ngZone = inject(NgZone);
    const env = inject<Environment>(ENV);
    const version = inject(VERSION);

    super(httpBackend, ngZone);
    this.variant = env.variant;
    this.version = version;
  }

  protected override alterHttpRequest(httpRequest: HttpRequest<any>): HttpRequest<any> {
    const userDetails: Profile = JSON.parse(localStorage.getItem('profileModule'))?.profile;

    httpRequest.body.userId = userDetails?.userId;
    httpRequest.body.firstName = userDetails?.firstName;
    httpRequest.body.lastName = userDetails?.lastName;
    httpRequest.body.level = NgxLoggerLevel[httpRequest.body.level];
    httpRequest.body.path = this.urlService.path();
    httpRequest.body.variant = this.variant;
    httpRequest.body.version = this.version;

    return httpRequest;
  }
}
